import { STATE_TAX_RATES } from "./states";

const MEDICARE_RATE = 0.0145;
const SS_RATE = 0.062;
const FED_RATE = 0.1;

const num = (v, d = 0) => {
  const n = parseFloat(v);
  return Number.isFinite(n) ? n : d;
};

export const money = (v) =>
  `$${num(v).toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;

export const emptyForm = () => ({
  firstName: "",
  lastName: "",
  state: "",
  ssnLast4: "",
  employeeAddress: "",
  companyName: "",
  companyAddress: "",
  employerNumber: "",
  bankName: "",
  department: "",
  payPeriodStart: "",
  payPeriodEnd: "",
  payDate: "",
  paymentMethod: "direct_deposit",
  earnings: [{ description: "Regular", payRate: "", hours: "" }],
  payPeriodsYTD: 1,
  medicalInsurance: "",
  benefits401k: "",
  federalWithholding: "",
  stateWithholding: "",
  filingStatus: "S",
  federalAllowances: 0,
});

export function computePaystub(fd) {
  const periods = Math.max(1, num(fd.payPeriodsYTD, 1));
  let grossCurrent = 0;
  let totalHours = 0;
  const earnings = (fd.earnings || []).map((line) => {
    const rate = num(line.payRate);
    const hours = num(line.hours);
    const current = Math.round(rate * hours * 100) / 100;
    grossCurrent += current;
    totalHours += hours;
    return {
      description: line.description || "Regular",
      payRate: rate,
      hours,
      current,
      ytd: Math.round(current * periods * 100) / 100,
    };
  });
  grossCurrent = Math.round(grossCurrent * 100) / 100;

  const state = (fd.state || "").toUpperCase();
  const stateRatePct = STATE_TAX_RATES[state] ?? 0;
  const stateRate = stateRatePct / 100;

  const federal =
    fd.federalWithholding === "" || fd.federalWithholding == null
      ? Math.round(grossCurrent * FED_RATE * 100) / 100
      : num(fd.federalWithholding);
  const stateTax =
    fd.stateWithholding === "" || fd.stateWithholding == null
      ? Math.round(grossCurrent * stateRate * 100) / 100
      : num(fd.stateWithholding);
  const medicare = Math.round(grossCurrent * MEDICARE_RATE * 100) / 100;
  const social = Math.round(grossCurrent * SS_RATE * 100) / 100;

  const taxes = [
    { description: "Federal Income Tax", current: federal },
    { description: "Social Security", current: social },
    { description: "Medicare", current: medicare },
    { description: state ? `${state} State Income Tax` : "State Income Tax", current: stateTax },
  ].map((t) => ({ ...t, ytd: Math.round(t.current * periods * 100) / 100 }));

  const medical = num(fd.medicalInsurance);
  const benefits = num(fd.benefits401k);
  const deductions = [
    { description: "Medical Insurance", current: medical },
    { description: "Benefits / 401(k)", current: benefits },
  ].map((d) => ({ ...d, ytd: Math.round(d.current * periods * 100) / 100 }));

  const totalTax = taxes.reduce((s, t) => s + t.current, 0);
  const totalDed = deductions.reduce((s, d) => s + d.current, 0);
  const netCurrent = Math.round((grossCurrent - totalTax - totalDed) * 100) / 100;

  return {
    earnings,
    taxes,
    deductions,
    totalHours: Math.round(totalHours * 100) / 100,
    grossCurrent,
    grossYTD: Math.round(grossCurrent * periods * 100) / 100,
    netCurrent,
    netYTD: Math.round(netCurrent * periods * 100) / 100,
    stateRatePct,
    periods,
  };
}
